import { GET_API } from "../../Functionalities/APIs";
import { insightsUrl } from "../../Constants/apiUrls";
import { user_id } from "../../Functionalities/Config";
import { cacheKey, readCache, toQueryString, writeCache } from "../../Functionalities/insightsCache";

export const loadInsights = async (params) => {
  const key = cacheKey(user_id, params);
  const cached = readCache(key);
  if (cached) return cached;
  const result = await GET_API("", toQueryString(params), insightsUrl);
  if (!result || !result.data || result.data.Status === false) return 0;
  writeCache(key, result.data);
  return result.data;
};
